import React, { useMemo, useState } from 'react';

import { Tabs, TreeSelect } from 'antd';

import { Branding } from './Branding';
import { Events } from './Events';
import { useSelector } from 'react-redux';
import { Channels } from './Channels';

const TrackTrace = () => {
  const role = useSelector((state) => state.auth.user.role);

  const [companyId, setCompanyId] = useState(null);
  const [locationId, setLocationId] = useState(null);

  const companies = useSelector((state) => state.auth.user.companies);
  const locations = useSelector((state) => state.auth.user.locations);

  const onChange = (v, props) => {
    if (!props.type) {
      return;
    }
    switch (props.type) {
      case 'company':
        setCompanyId(companies.find((c) => c.companyId === v)?.id);
        setLocationId(null);
        break;
      case 'location':
        setLocationId(locations.find((l) => l.locationId === v)?.id);
        break;
      default:
        break;
    }
  };

  const options = useMemo(() => {
    let res = [];

    if (['COMPANY_OWNER', 'ADMIN'].includes(role)) {
      res.push({
        value: 'companies',
        title: 'Companies',
        children: [
          ...(companies || []).map((company) => ({
            label: company.name,
            value: company.companyId,
            type: 'company',
          })),
        ],
      });
    }

    if (['COMPANY_OWNER', 'ADMIN', 'LOCATION_USER'].includes(role)) {
      res.push({
        value: 'locations',
        title: 'Locations',
        key: 'locations',
        children: [
          ...(locations || []).map((location) => ({
            label: location.name,
            value: location.locationId,
            type: 'location',
          })),
        ],
      });
    }
    return res;
  }, [companies, locations, role]);

  const items = [
    {
      key: 'branding',
      label: 'Branding',
      children: <Branding companyId={companyId} locationId={locationId} />,
    },
    {
      key: 'event',
      label: 'Events',
      children: <Events companyId={companyId} locationId={locationId} />,
    },
    {
      key: 'channels',
      label: 'Channels',
      children: <Channels companyId={companyId} locationId={locationId} />,
    },
  ];

  return (
    <div className="info">
      <div className="info-content">
        <h3>Track & Trace</h3>
        <h5>Enable track and trace functionality for your deliveries</h5>

        <h4>Please select the account, company or location you want to apply settings to:</h4>
        <TreeSelect
          placeholder="Please select"
          className="select-small"
          treeData={options}
          treeDefaultExpandAll
          onSelect={onChange}
          style={{ minWidth: '200px' }}
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <Tabs defaultActiveKey="events" items={items} destroyInactiveTabPane />
      </div>
    </div>
  );
};

export default TrackTrace;
